import React, { createContext, useState, useEffect, useContext } from 'react';
import { defaultRequestQueueManager } from 'components/layout_and_quote_builder/utils/RequestQueueManager.js';

const ProgressContext = createContext();

export const useProgress = () => {
  const context = useContext(ProgressContext);
  if (!context) {
    throw new Error('useProgress must be used within a ProgressProvider');
  }
  return context;
};

// `queue` is which RequestQueueManager the bar is reporting on, defaulting to the shared one so every existing
// caller -- the legacy Manufacturing Cost Calculator among them -- keeps exactly the queue and the counts it
// had. Frank passes its own (sectionAnswerQueue), because its requests stopped being the heavy kind the shared
// queue's cap exists to throttle and it needs them all in flight at once; its progress must then follow the
// queue it is actually using, or the bar would report on one nobody is filling.
export const ProgressProvider = ({ children, queue = defaultRequestQueueManager }) => {
  const [progress, setProgress] = useState({
    completed: 0,
    total: 0,
    percentage: 0
  });

  useEffect(() => {
    // Reset progress when provider mounts
    queue.reset();

    // Subscribe to progress updates
    const unsubscribe = queue.onProgress((progressInfo) => {
      setProgress(progressInfo);
    });

    // Cleanup on unmount
    return () => {
      unsubscribe();
    };
  }, [queue]);

  const resetProgress = () => {
    queue.reset();
  };

  return (
    <ProgressContext.Provider value={{ progress, resetProgress }}>
      {children}
    </ProgressContext.Provider>
  );
};

export default ProgressContext;
